import { formatMinutesToHoursDecimal, formatTimeToHoursAndMinutes } from "../../../../utils/CommonFunctions";
import { colors } from "../../../../config/colors";
import { getJobTitleLabel, getJobTitleLabelPlural } from "../../../../utils/jobTitleLabel";

export function getCharts() {
  const jobLabel = getJobTitleLabel();
  const jobPluralLabel = getJobTitleLabelPlural();
  return [
    {
        name: "jobsPerDay",
        chartType: "line",
        displayName: `${jobPluralLabel} Per Day Comparison`,
        subTitle: `Daily ${jobLabel.toLowerCase()} completion trends comparison`,
        index: "date",
        categories: ["filter1Jobs", "filter2Jobs"],
        categoryNames: ["Comparison Period", "Base Period"],
        tooltipValueFormatter: (value) => `${value} ${jobPluralLabel.toLowerCase()}`,
        yAxisValueFormatter: (value) => value,
        colors: [colors.filters.set1.secondary, colors.filters.set2.secondary]
    },
    { 
        name: "timePerJob", 
        chartType: "line",
        displayName: `Time Per ${jobLabel}`, 
        subTitle: `Average time spent on ${jobPluralLabel.toLowerCase()} comparison`, 
        index: "date", 
        categories: ["filter1TimeSpent", "filter2TimeSpent"],
        categoryNames: ["Comparison Period", "Base Period"],
        valueFormatter: (value) => `${formatMinutesToHoursDecimal(value)}`,
        tooltipValueFormatter: (value) => formatTimeToHoursAndMinutes(value),
        yAxisValueFormatter: (value) => `${formatMinutesToHoursDecimal(value)}`,
        colors: [colors.filters.set1.secondary, colors.filters.set2.secondary]
    },
    { 
        name: "timePerTask", 
        chartType: "line",
        displayName: "Time Per Task", 
        subTitle: "Daily time spent on tasks comparison", 
        index: "date", 
        categories: ["filter1TimeSpent", "filter2TimeSpent"],
        categoryNames: ["Comparison Period", "Base Period"],
        valueFormatter: (value) => `${formatMinutesToHoursDecimal(value)}`,
        tooltipValueFormatter: (value) => formatTimeToHoursAndMinutes(value),
        yAxisValueFormatter: (value) => `${formatMinutesToHoursDecimal(value)}`,
        colors: [colors.filters.set1.secondary, colors.filters.set2.secondary]
    },
    {
        name: "averageTimePerUnit",
        chartType: "line",
        displayName: "Average Time Per Unit",
        subTitle: "Average time spent per unit comparison",
        index: "date",
        categories: ["filter1TimeSpent", "filter2TimeSpent"],
        categoryNames: ["Comparison Period", "Base Period"],
        valueFormatter: (value) => `${formatMinutesToHoursDecimal(value)}`,
        tooltipValueFormatter: (value) => formatTimeToHoursAndMinutes(value),
        yAxisValueFormatter: (value) => `${formatMinutesToHoursDecimal(value)}`,
        colors: [colors.filters.set1.secondary, colors.filters.set2.secondary]
    },
    {
        name: "unitsPerDay",
        chartType: "line",
        displayName: "Units Per Day",
        subTitle: "Daily units processed comparison",
        index: "date",
        categories: ["filter1Units", "filter2Units"],
        categoryNames: ["Comparison Period", "Base Period"],
        tooltipValueFormatter: (value) => `${value} units`,
        yAxisValueFormatter: (value) => value,
        colors: [colors.filters.set1.secondary, colors.filters.set2.secondary]
    },
    {
        name: "tasksPerVisit",
        chartType: "line",
        displayName: "Tasks Per Visit",
        subTitle: "Number of tasks completed per visit comparison",
        index: "date",
        categories: ["filter1Tasks", "filter2Tasks"],
        categoryNames: ["Comparison Period", "Base Period"],
        tooltipValueFormatter: (value) => `${value} tasks`,
        yAxisValueFormatter: (value) => value.toFixed(1),
        colors: [colors.filters.set1.secondary, colors.filters.set2.secondary]
    }
  ];
}

export const charts = getCharts();

// {
//     "jobsPerDay": [
//         {
//             "date": "2025-05-24",
//             "filter1Jobs": 2,
//             "filter2Jobs": 2
//         },
//         {
//             "date": "2025-05-25",
//             "filter1Jobs": 1,
//             "filter2Jobs": 1
//         },
//         {
//             "date": "2025-05-28",
//             "filter1Jobs": 1,
//             "filter2Jobs": 1
//         },
//         {
//             "date": "2025-05-29",
//             "filter1Jobs": 2,
//             "filter2Jobs": 2
//         }
//     ],
//     "timePerJob": [
//         {
//             "date": "2025-05-24",
//             "filter1TimeSpent": 24.3,
//             "filter2TimeSpent": 24.3
//         },
//         {
//             "date": "2025-05-25",
//             "filter1TimeSpent": 52.6,
//             "filter2TimeSpent": 52.6
//         },
//         {
//             "date": "2025-05-28",
//             "filter1TimeSpent": 0.3,
//             "filter2TimeSpent": 0.3
//         },
//         {
//             "date": "2025-05-29",
//             "filter1TimeSpent": 56,
//             "filter2TimeSpent": 56
//         }
//     ],
//     "timePerTask": [
//         {
//             "date": "2025-05-24",
//             "filter1TimeSpent": 3.1,
//             "filter2TimeSpent": 3.1
//         },
//         {
//             "date": "2025-05-25",
//             "filter1TimeSpent": 8.8,
//             "filter2TimeSpent": 8.8
//         },
//         {
//             "date": "2025-05-28",
//             "filter1TimeSpent": 0.2,
//             "filter2TimeSpent": 0.2
//         },
//         {
//             "date": "2025-05-29",
//             "filter1TimeSpent": 54.1,
//             "filter2TimeSpent": 54.1
//         }
//     ],
//     "tasksPerVisit": [
//         {
//             "date": "2025-05-24",
//             "filter1Tasks": 6.5,
//             "filter2Tasks": 6.5
//         },
//         {
//             "date": "2025-05-25",
//             "filter1Tasks": 6,
//             "filter2Tasks": 6
//         },
//         {
//             "date": "2025-05-28",
//             "filter1Tasks": 2,
//             "filter2Tasks": 2
//         },
//         {
//             "date": "2025-05-29",
//             "filter1Tasks": 1.5,
//             "filter2Tasks": 1.5
//         }
//     ]
// }